import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import JoinTeam from "@/pages/JoinTeam";
import Dashboard from "@/pages/Dashboard";
import Vendors from "@/pages/Vendors";
import Products from "@/pages/Products";
import Inventory from "@/pages/Inventory";
import PurchaseOrders from "@/pages/PurchaseOrders";
import CreatePO from "@/pages/CreatePO";
import ViewPO from "@/pages/ViewPO";
import Installers from "@/pages/Installers";
import Installations from "@/pages/Installations";
import CreateInstallation from "@/pages/CreateInstallation";
import ViewInstallation from "@/pages/ViewInstallation";
import Customers from "@/pages/Customers";
import Team from "@/pages/Team";

function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/register" element={user ? <Navigate to="/" replace /> : <Register />} />
      <Route path="/join/:inviteCode" element={user ? <Navigate to="/" replace /> : <JoinTeam />} />
      
      {/* Protected routes */}
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="products" element={<Products />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="purchase-orders" element={<PurchaseOrders />} />
        <Route path="purchase-orders/new" element={<CreatePO />} />
        <Route path="purchase-orders/:id" element={<ViewPO />} />
        <Route path="installers" element={<Installers />} />
        <Route path="installations" element={<Installations />} />
        <Route path="installations/new" element={<CreateInstallation />} />
        <Route path="installations/:id" element={<ViewInstallation />} />
        <Route path="customers" element={<Customers />} />
        <Route path="team" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Team />
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
